import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { translateCountry, capitalizeFirstLetter } from '../../../../../attendee/detail/components/utils';
import { Card, ContentCard, HeaderCard, Icon, SubTitleCard, TitleCard } from '@weezevent/nacre';
import ModerationProfileRequesterInformationsForm from './moderationProfileRequesterInformationsForm';
import Style from '../../moderationProfile.module.css';

export default function ModerationProfileRequesterInformations({ order, organizationId, orderId, flowId, syncOrder, attendee }) {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const [editRequester, setEditRequester] = React.useState(false);
    const locale = i18n.language;

    const allFieldsNotEditable = order?.buyer_form?.every(item => !item.allow_modification);

    const formatFieldValue = React.useCallback(
        field => {
            if (!field.answer) {
                return '';
            }

            if (field.field_type === 'country') {
                return capitalizeFirstLetter(translateCountry(locale, field.answer));
            }

            return field.answer.replace('None', '');
        },
        [locale]
    );

    return (
        <Card id="requester" className={`${Style['attendee-card']} ${Style['attendee-requesterInfos']}`}>
            <HeaderCard className={Style['attendee-cardInfos-header']}>
                <div>
                    <TitleCard title={t('ticket.moderation.attendee.requesterInformations.title')} />
                    <SubTitleCard title={t('ticket.moderation.attendee.requesterInformations.subtitle')} />
                </div>
                {!editRequester && order?.buyer_form && !allFieldsNotEditable && (
                    <div className={Style['attendee-cardInfos-editCta']} onClick={() => setEditRequester(true)}>
                        <span>{t('ticket.common.action.modify')}</span>
                        <Icon name="edit" />
                    </div>
                )}
            </HeaderCard>
            <ContentCard>
                {order?.buyer_form && order?.buyer_form.length > 0 ? (
                    editRequester ? (
                        <ModerationProfileRequesterInformationsForm
                            organizationId={organizationId}
                            order={order}
                            orderId={orderId}
                            flowId={flowId}
                            syncOrder={syncOrder}
                            setEditRequester={setEditRequester}
                        />
                    ) : (
                        <ul className={Style['attendee-infos-listItem']}>
                            {order.buyer_form
                                .filter(entry => !(entry.field_type === 'file' || entry.field_type === 'divider'))
                                .sort((a, b) => a.order - b.order)
                                .map((formEntry, index) => (
                                    <li key={index}>
                                        <span className={Style['attendee-infos-listItem-label']}>{formEntry.question}</span>
                                        <b className={Style['attendee-infos-listItem-answer']}>{formatFieldValue(formEntry)}</b>
                                    </li>
                                ))}
                        </ul>
                    )
                ) : (
                    <Card.EmptyState
                        icon={<Icon name="list" />}
                        title={t('ticket.common.noData')}
                        subtitle={t('ticket.moderation.attendee.formEmptyStateSubtitle')}
                        labelButton={t('ticket.moderation.attendee.formEmptyStateCta')}
                        onClick={() => {
                            history.push(`/ticket/O${organizationId}/E${attendee.event_id}/settings/forms`);
                        }}
                    />
                )}
            </ContentCard>
        </Card>
    );
}
